import { render } from "./DocumentPreviewTopbar.vue?vue&type=template&id=2a9a8240&scoped=true"
import script from "./DocumentPreviewTopbar.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewTopbar.vue?vue&type=script&lang=js"

import "./DocumentPreviewTopbar.vue?vue&type=style&index=0&id=2a9a8240&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9a8240"]])

export default __exports__